import { IShoppingCartSidebarCommandFacade as IShoppingCartSidebarCommandPublicFacade } from '../../domain/ports/primary/shopping-cart.ports';
import { SHOPPING_CART_SIDEBAR_FACADE } from '../../ui/tokens/shopcart.tokens';
import { SidebarCommandFacade } from '../sidebar/sidebar-command.facade';

// #region PUBLIC TOKENS
export const PublicTokens = {
    SHOPPING_CART_SIDEBAR_FACADE: SHOPPING_CART_SIDEBAR_FACADE,
};
// #endregion PUBLIC TOKENS

// #region PUBLIC PORTS
// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace PublicPorts {
    export type IShoppingCartSidebarCommandFacade = IShoppingCartSidebarCommandPublicFacade;
}

export const PublicImpl = {
    ShoppingCartSidebarFacade: SidebarCommandFacade,
};
// #endregion PUBLIC PORTS
